import { cloneElement } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import PageHeader from '../pageHeader';
import {
  SIDEBAR_WIDTH,
  SIDEBAR_WIDTH_SMALL,
} from '../../../constants/sidebarNavigation';

const useStyles = makeStyles(({ breakpoints, spacing }) => ({
  root: {
    marginLeft: SIDEBAR_WIDTH_SMALL,
    width: `calc(100vw - ${SIDEBAR_WIDTH_SMALL}px)`,
    [breakpoints.up('xl')]: {
      marginLeft: SIDEBAR_WIDTH,
      width: `calc(100vw - ${SIDEBAR_WIDTH}px)`,
    },
  },
  mainWrapper: {
    display: 'flex',
    height: '100vh',
  },
  main: {
    flexGrow: 1,
    padding: spacing(0, 4.5, 0, 4.5),
    height: '100%',
    overflowY: 'auto',
    [breakpoints.up('xLg')]: {
      padding: spacing(0, 10, 0, 6),
    },
    [breakpoints.up('xl')]: {
      padding: spacing(0, 12, 0, 12),
    },
  },
  content: {
    width: '100%',
    maxWidth: 900,
    paddingBottom: spacing(12),
  },
  mediumWidthContent: {
    maxWidth: 1350,
  },
  fullWidthContent: {
    maxWidth: '100%',
  },
  noContentSpacing: {
    paddingBottom: 0,
  },
}));

const PageContainer = ({
  mainClass = null,
  contentClass = null,
  translations,
  children,
  location,
  navigate,
  auth,
  accessControl,
  organizationSettings,
  headerProps = {},
  isLoading = false,
  navigationItems = [],
  isFullWidthContent = false,
  isMediumWidthContent = false,
  shouldRemoveSpacing = false,
  shouldPassProps = true,
  pageScrollRef,
  ...rest
}) => {
  const classes = useStyles();

  const goToProfilePage = userId => navigate(`/people/${userId}`);

  return (
    <div className={classes.root} id="pageContainer">
      <div className={classes.mainWrapper}>
        <div
          ref={pageScrollRef}
          className={classNames(classes.main, mainClass)}
        >
          {!isLoading && (
            <PageHeader
              translations={translations.pageHeader}
              navigate={navigate}
              location={location}
              title={translations.title}
              auth={auth}
              accessControl={accessControl}
              organizationSettings={organizationSettings}
              navItems={navigationItems}
              onGoToProfile={goToProfilePage}
              {...headerProps}
            />
          )}
          <div
            className={classNames(
              classes.content,
              {
                [classes.mediumWidthContent]: isMediumWidthContent,
                [classes.fullWidthContent]: isFullWidthContent,
                [classes.noContentSpacing]: shouldRemoveSpacing,
              },
              contentClass
            )}
          >
            {shouldPassProps
              ? cloneElement(children, {
                  location,
                  navigate,
                  translations,
                  auth,
                  accessControl,
                  organizationSettings,
                  goToProfilePage,
                  ...rest,
                })
              : children}
          </div>
        </div>
      </div>
    </div>
  );
};

PageContainer.propTypes = {
  mainClass: PropTypes.string,
  contentClass: PropTypes.string,
  location: PropTypes.object.isRequired,
  navigate: PropTypes.func.isRequired,
  translations: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  auth: PropTypes.object.isRequired,
  accessControl: PropTypes.object.isRequired,
  organizationSettings: PropTypes.object.isRequired,
  isFullWidthContent: PropTypes.bool,
  isMediumWidthContent: PropTypes.bool,
  isLoading: PropTypes.bool,
  shouldRemoveSpacing: PropTypes.bool,
  shouldPassProps: PropTypes.bool,
  headerProps: PropTypes.shape({}),
  navigationItems: PropTypes.arrayOf(PropTypes.shape({})),
};

export default PageContainer;
